export default {
  name: "HeroSection",

  data() {
    return ({
      hero_cards: [
        {
          key: "utilities",
          label: "Utilities",
          icon: "bi bi-building",
          description: "12 active",
        },
        {
          key: "consumption",
          label: "Consumption",
          icon: "bi bi-lightning-charge-fill",
          description: "Optimised",
        },
        {
          key: "security",
          label: "Security",
          icon: "bi bi-shield-lock-fill",
          description: "Protected",
        },
        {
          key: "connectivity",
          label: "Connectivity",
          icon: "bi bi-wifi",
          description: "All online",
        },
      ],
    });
  },
};
